import React from 'react'

function IconWord({ className = '' }) {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50' width={40} height={40} className={className}>
            <path d='M11.25 45 V5 H30 L38.75 13.75 V45 Z' fill='#ffffff' />
            <path d='M11.25 45 V5 H30 L38.75 13.75 V45 Z' fill='none' stroke='#0000a0' strokeWidth='2.5' />
            <path d='M30 5 V13.75 H38.75' fill='none' stroke='#0000a0' strokeWidth='2.5' />
            <rect x='5' y='23.75' width='40' height='15' fill='#0000a0' />
            <text
                x='25'
                y='31.25'
                fill='#ffffff'
                fontFamily='Arial, Helvetica, sans-serif'
                fontWeight='bold'
                fontSize='11.875'
                textAnchor='middle'
                dominantBaseline='central'
            >
                DOC
            </text>
        </svg>
    )
}

export default IconWord
